class FrequentlyBoughtTogether {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    // Add click handlers to all card ATC buttons
    const atcButtons = this.container.querySelectorAll('.fbt__card-atc-btn');
    atcButtons.forEach(button => {
      button.addEventListener('click', (e) => this.addToCart(e.currentTarget));
    });
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');

    try {
      // Collect section IDs that need refreshing (cart drawer registers itself here)
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      // Add item to cart via JSON body so sections can be included
      const addResponse = await fetch(FoxTheme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await addResponse.json();

      if (parsedState.status) {
        this.handleCartError(parsedState);
        return;
      }

      // Fetch updated cart state (GET, not POST)
      const cartResponse = await fetch(FoxTheme.routes.cart_url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      });
      const cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      // Update header cart count and cart drawer sections
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

      // Notify other listeners
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));

      // Open side cart drawer
      this.showCartDrawer(button);

    } catch (error) {
      console.error('FBT add to cart error:', error);
    } finally {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-disabled');
    }
  }

  showCartDrawer(button) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.show(button);
  }

  handleCartError(parsedState) {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'frequently-bought-together',
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', { detail: { errorMessage: parsedState.description } })
    );
  }
}

// Initialize all frequently bought together components
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-fbt-container]');
  containers.forEach(container => {
    new FrequentlyBoughtTogether(container);
  });

  document.querySelectorAll('[data-fbt-classic-container]').forEach(container => {
    new FrequentlyBoughtTogetherClassic(container);
  });
});

class FrequentlyBoughtTogetherClassic {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.container.querySelectorAll('[data-fbt-card]').forEach(card => {
      if (card.hasAttribute('data-fbt-locked')) return;
      const cb = card.querySelector('[data-fbt-checkbox]');
      if (cb) cb.addEventListener('change', () => this.updateSummary());
    });
    this.container.querySelector('[data-fbt-classic-atc]')
      .addEventListener('click', () => this.addAllToCart());
    this.updateSummary();
  }

  selectedCards() {
    return Array.from(this.container.querySelectorAll('[data-fbt-card]')).filter(card => {
      if (card.hasAttribute('data-fbt-locked')) return true;
      const cb = card.querySelector('[data-fbt-checkbox]');
      return cb && cb.checked;
    });
  }

  updateSummary() {
    const selected = this.selectedCards();
    const total = selected.reduce((sum, c) => sum + parseInt(c.dataset.price || 0, 10), 0);
    const compareTotal = selected.reduce((sum, c) => sum + parseInt(c.dataset.comparePrice || 0, 10), 0);
    const savings = compareTotal - total;
    const count = selected.length;

    const totalEl = this.container.querySelector('[data-fbt-total]');
    if (totalEl) totalEl.textContent = this.formatMoney(total) + '/-';

    const labelEl = this.container.querySelector('[data-fbt-atc-label]');
    if (labelEl) labelEl.textContent = 'Add ' + count + ' to Cart';

    const savingsEl = this.container.querySelector('[data-fbt-savings]');
    if (savingsEl) {
      savingsEl.textContent = savings > 0
        ? 'Get ' + count + ' Products at just ' + this.formatMoney(total) + ' and save ' + this.formatMoney(savings)
        : '';
    }

    const btn = this.container.querySelector('[data-fbt-classic-atc]');
    if (btn) btn.disabled = count === 0;
  }

  async addAllToCart() {
    const selected = this.selectedCards();
    if (!selected.length) return;

    const btn = this.container.querySelector('[data-fbt-classic-atc]');
    btn.classList.add('btn--loading');

    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const items = selected.map(c => ({ id: parseInt(c.dataset.variantId, 10), quantity: 1 }));

      const addResponse = await fetch(FoxTheme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: JSON.stringify({ items, sections: sectionsToBundle, sections_url: window.location.pathname }),
      });

      const parsedState = await addResponse.json();

      if (parsedState.status) {
        console.error('FBT Classic cart error:', parsedState);
        return;
      }

      // Fetch updated cart for header count
      const cartResponse = await fetch(FoxTheme.routes.cart_url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      });
      const cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));

      // Open side cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.show(btn);

    } catch (error) {
      console.error('FBT Classic add to cart error:', error);
    } finally {
      btn.classList.remove('btn--loading');
    }
  }

  formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }
}
